/* eslint-disable react/jsx-no-comment-textnodes */
import { FC, useEffect } from 'react';
import { EndUserSettingsFormProps } from './types';
import { Paper, Grid, Button, TextField } from '@material-ui/core';
import { useStyles } from './styles';
import { observer } from 'mobx-react-lite';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import { Controller, useForm } from 'react-hook-form';
import { useStore } from 'hooks/useRootStore';
import { useMutation, useQuery } from 'react-query';
import { useAppPreloader } from 'hooks/useAppPreloader';

export const EndUserAttributeForm: FC<EndUserSettingsFormProps> = observer(({ type, description }) => {
  const classes = useStyles();
  const {
    endUserSettingsFormStore: { UserIdGenrate, portalSettingsget, endUserConfigSettings },
    notificationStore: { openNotification },
  } = useStore();

  const portalSettingsgetReq = useQuery('portalSettingsgetReq', () => portalSettingsget(), {
    onError: () => openNotification('error', `Can't get data`),
  });

  const UserIdGenratereq = useMutation((data: any) => UserIdGenrate(data), {
    mutationKey: 'UserIdGenratereq',
    onSuccess: (e) => {
      openNotification('success', 'Saved!!');
      portalSettingsgetReq.refetch();
    },
    onError: (e) => openNotification('error', `Field is required`),
  });
  useAppPreloader(portalSettingsgetReq.isLoading);

  const { control, handleSubmit } = useForm<any>();
  const onSubmit = (data: any) => {
    return UserIdGenratereq.mutate(data);
  };

  useEffect(() => {
    document.title = 'EasyIdentity: Settings: UserId';
  }, []);

  return (
    <>
      <h1 className={classes.textBox}>
        {' '}
        {/* Attribute names can be changed here. Once updated, the new names will be reflected throughout the UI. Any newly added attributes will also be displayed across the UI. */}
        Attribute names can be changed here. Once they are changed, then the attribute is shown everywhere in the UI
        with the new/changed name.
      </h1>
      <form onSubmit={handleSubmit(onSubmit)}>
        {!portalSettingsgetReq.isLoading && (
          <>
            <div className={classes.leftCol}>
              <Grid item xs={12} className={classes.btnContainer}>
                <Button className={classes.submitBtn} type='submit' variant='contained'>
                  Save changes
                </Button>
              </Grid>
            </div>
            <Paper className={classes.paper}>
              <TableContainer>
                <Table className={`${classes.border}`} aria-label='simple table' style={{ margin: '20px 0px' }}>
                  <TableBody>
                    <TableRow>
                      <TableCell className={`${classes.border} ${classes.cellTitle}`}>User ID </TableCell>
                      <TableCell className={`${classes.border} ${classes.cellLink}`}>
                        {' '}
                        <Controller
                          key='1'
                          name='userId'
                          control={control}
                          rules={{ required: true }}
                          render={({ field, fieldState: { invalid } }) => (
                            <Grid container className={classes.row}>
                              <TextField
                                {...field}
                                error={invalid}
                                placeholder='User Id'
                                defaultValue={endUserConfigSettings?.userId ? endUserConfigSettings?.userId : ``}
                                helperText={invalid ? 'Required field' : ''}
                                className={`${classes.input} ${classes.cellInputLink}`}
                                InputProps={{ disableUnderline: true }}
                              />
                            </Grid>
                          )}
                        />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </>
        )}
      </form>
    </>
  );
});
